import Input from "@material-tailwind/react/components/Input"
import { ErrorMessage, Field, FieldInputProps, FormikProps } from "formik"

type Props = {
  name: string
}

const InputNumber = (props: Props) => {
  const { name } = props

  return (
    <Field type="text" name={name} >
      {({
        field,
        form,
      }: {
        field: FieldInputProps<any>
        form: FormikProps<any>
      }) => {
        return (
          <div>
            <Input
              type="number"
              name={name}
              min={1}
              onChange={field.onChange}
              onBlur={field.onBlur}
              value={field.value}
              className=" rounded-none bg-white h-[40px] w-[60px] text-center !p-0 !border-t-blue-gray-200 focus:!border-t-blue-gray-900"
              labelProps={{
                className: "before:rounded-tl-none after:rounded-tr-none hidden",
              }}
              containerProps={{
                className: "!h-[40px] !w-[60px] min-w-[60px]",
              }}
              crossOrigin={undefined}
              aria-label={name}
            />
            <ErrorMessage
              name={name}
              component="p"
              className="text-red-500 text-xs mt-1 text-left"
            />
          </div>
        )
      }}
    </Field>
  )
}

export default InputNumber
